import { Injectable } from "@angular/core";
import { v4 as UUID} from 'uuid'
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { lastValueFrom } from "rxjs";
import { Tag, TagGroup } from "../../common/organisation";
import { TagGroupDialogComponent } from "./tag-group-dialog.component";
import { OrganisationService } from "../organisation.service";
import { UserService } from "../../user/user.service";
import { environment } from "../../../environments/environment";
import { getColourStyleForTagIndex, getIconForTagIndex, nextTagIndex, TAG_COLOURS } from "./tag-colours";

@Injectable({
    providedIn: 'root'
  })
export class TagsService {

    constructor(private dialog: MatDialog, private organisationService:OrganisationService, private userService:UserService) {
    }

    getTagColours() {
        return TAG_COLOURS
    }

    getNextTagIndex(tagGroup:TagGroup):number {
        return nextTagIndex((tagGroup.tags || []).map(t => t.tagIndex))
    }

    getIconTagIndex(index:number):string {
        return getIconForTagIndex(index)
    }

    getIconForTag(tag:Tag):string {
        return this.getIconTagIndex(tag.tagIndex)
    }

    getColourStyleForTag(tag:Tag):string {
        return this.getColourStyleForTagIndex(tag.tagIndex)
    }

    getColourStyleForTagIndex(i:number):string {
        return getColourStyleForTagIndex(i)
    }

    // resolves with what happened, so callers showing the group can update. The dialog edits a copy: the group only
    // changes once the server has saved it, and nothing changes if that fails (the error has been shown)
    async openTagGroupDialog(tagGroup?:TagGroup):Promise<'saved'|'deleted'|undefined> {
        const data:TagGroup = tagGroup ? structuredClone(tagGroup) : {_key:UUID(), name:'', description:'', tags:[]} as TagGroup

        const dialogConfig = new MatDialogConfig();

        const extended = this.userService.isSysAdmin() && this.organisationService.organisation?._key === environment.demoOrganisationKey

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = extended?"800px":"550px"
        dialogConfig.hasBackdrop = true

        dialogConfig.data = {tagGroup:data, extended}

        const result:TagGroup = await lastValueFrom(this.dialog.open(TagGroupDialogComponent, dialogConfig).afterClosed())
        if (!result) return undefined
        try {
            if (result.deleted) {
                await this.organisationService.deleteTagGroup(result)
                return 'deleted'
            }
            if (tagGroup) {
                await this.organisationService.updateTagGroup(result)
                // pages showing the group see the saved details
                Object.assign(tagGroup, result)
                this.organisationService.reloadOrganisation()
            }else await this.organisationService.createTagGroup(result)
            return 'saved'
        }catch(err) {
            return undefined
        }
    }

}
